import { Route, Switch, useLocation } from "react-router-dom";
import LandingPage from "../pages/Landing/LandingPage";
import CustomerProfile from "../pages/Landing/pages/CustomerProfile/CustomerProfile";
import PartnerProfile from "../pages/Landing/pages/PartnerProfile/PartnerProfile";
import SellerProfile from "../pages/Landing/pages/SellerProfile/SellerProfile";
import ManagerProfile from "../pages/Landing/pages/ManagerProfile/ManagerProfile";
import StoreProfile from "../pages/Landing/pages/StoreProfile/StoreProfile";
import WhiteLabelProfile from "../pages/Landing/pages/WhiteLabelProfile/WhiteLabelProfile";
import PromoterProfile from "../pages/Landing/pages/PromoterProfile/PromoterProfile";
import EmpresasProfile from "../pages/Landing/pages/EmpresasProfile/EmpresasProfile";
import PlanosPage from "../pages/Landing/pages/PlanosPage/PlanosPage";
import SobrePage from "../pages/Landing/pages/SobrePage/SobrePage";
import Layout from "../Layouts/Layout";
import ShoppingCart from "../pages/ShoppingCart/ShoppingCart";
import Login from "../pages/Login/Login";
import ResetPassword from "../pages/Login/ResetPassword";
import FedernetHandoff from "../pages/Login/FedernetHandoff";
import EmailConfirmation from "../pages/EmailConfirmation/EmailConfirmation";
import React, { lazy, Suspense } from "react";
import Loading from "../components/Loading/Loading";
import UnderConstruction from "../pages/UnderConstruction/UnderConstruction";
import Shop from "../pages/Shop/Shop";
import ProductInfo from "../pages/ProductInfo/ProductInfo";
import UserStorePage from "../pages/UserStorePage/UserStorePage";
import PrivacyPolicy from "../pages/privacypolicy/PrivacyPolicy";
import CategoriesPage from "../pages/CategoriesPage/CategoriesPage";
import Confimea from "../pages/Confimea/Confimea";
import StoreSlugRoute from "./StoreSlugRoute";
import ConfimeaConfirmation from "../pages/Confimea/ConfimeaConfirmation";

const PartnerRegisterLazy = lazy(() => import("../pages/RegisterUser/components/PartnerRegister"));
const ManagerRegisterLazy = lazy(() => import("../pages/RegisterUser/components/ManagerRegister"));
const CustomerRegisterLazy = lazy(() => import("../pages/RegisterUser/components/CustomerRegister"));
const SellerRegisterLazy = lazy(() => import("../pages/RegisterUser/components/SellerRegister"));
const PromoterRegisterLazy = lazy(() => import("../pages/RegisterUser/components/PromoterRegister"));
const StoreRegisterLazy = lazy(() => import("../pages/RegisterUser/components/StoreRegister"));
// Canal de venda ScontiPoste (vitrine propria, carrinho com varios vendedores, so cartao)
const ChannelRoutesLazy = lazy(() => import("../pages/Channel/ChannelRoutes"));

const StoreRoutes = () => {
  function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();

  return (
    <Switch>
      {/* Antes do slug de loja: /scontiposte nunca e tratado como link personalizado */}
      <Route
        path="/scontiposte"
        render={() => (
          <Suspense fallback={<Loading />}>
            <ChannelRoutesLazy />
          </Suspense>
        )}
      />
      <Route path="/confimeaimprese" component={Confimea} />
      <Route path="/confimeaconfirmation" component={ConfimeaConfirmation} />
      <Route path="/landing" component={LandingPage} />
      <Route
        path="/cart-fringe-benefit"
        render={() => (
          <Layout>
            <ShoppingCart />
          </Layout>
        )}
      />
      <Route
        path="/cart"
        render={() => (
          <Layout>
            <ShoppingCart />
          </Layout>
        )}
      />
      <Route path="/login" render={() => <Login />} />
      <Route path="/federnet-handoff" component={FedernetHandoff} />
      <Route path="/requestPasswordChange" render={() => <ResetPassword />} />
      <Route
        path="/emailconfirmation"
        render={() => (
          <EmailConfirmation
            message={query.get("message")}
            title={query.get("title")}
            type={query.get("type")}
          />
        )}
      />
      <Route
        path="/orderconfirmation"
        render={() => (
          <EmailConfirmation
            message={query.get("message")}
            title={query.get("title")}
            type={query.get("type")}
            url={query.get("url")}
          />
        )}
      />
      <Route
        path="/businesspartner"
        render={() => (
          <Suspense fallback={<Loading />}>
            <PartnerRegisterLazy link={query.get("link")} />
          </Suspense>
        )}
      />
      <Route
        path="/areamanager"
        render={() => (
          <Suspense fallback={<Loading />}>
            <ManagerRegisterLazy
              link={query.get("link")}
              association={query.get("association")}
            />
          </Suspense>
        )}
      />
      <Route
        path="/specialcustomer"
        render={() => (
          <Suspense fallback={<Loading />}>
            <CustomerRegisterLazy link={query.get("link")} />
          </Suspense>
        )}
      />
      <Route path="/customer" render={() => <CustomerProfile />} />
      <Route path="/partner" render={() => <PartnerProfile />} />
      <Route path="/sellerprofile" render={() => <SellerProfile />} />
      <Route path="/manager" render={() => <ManagerProfile />} />
      <Route path="/storeprofile" render={() => <StoreProfile />} />
      <Route path="/white-label" render={() => <WhiteLabelProfile />} />
      <Route path="/promoter" render={() => <PromoterProfile />} />
      <Route path="/empresas" render={() => <EmpresasProfile />} />
      <Route path="/planos" render={() => <PlanosPage />} />
      <Route path="/sobre" render={() => <SobrePage />} />
      <Route
        path="/seller"
        render={() => (
          <Suspense fallback={<Loading />}>
            <SellerRegisterLazy link={query.get("link")} />
          </Suspense>
        )}
      />
      <Route
        path="/salepromoter"
        render={() => (
          <Suspense fallback={<Loading />}>
            <PromoterRegisterLazy link={query.get("link")} />
          </Suspense>
        )}
      />
      <Route
        path="/storeregister"
        render={() => (
          <Suspense fallback={<Loading />}>
            <StoreRegisterLazy link={query.get("link")} />
          </Suspense>
        )}
      />
      <Route path="/comingsoon" render={() => <UnderConstruction />} />
      <Route
        path="/shop"
        render={() => (
          <Layout hasSearch={true}>
            <Shop search={query.get("search")} />
          </Layout>
        )}
      />
      <Route
        path="/product/:id"
        render={({ match }) => (
          <Layout hasSearch={true}>
            <ProductInfo id={match.params.id} />
          </Layout>
        )}
      />
      <Route
        path="/store"
        render={() => (
          <Layout hasSearch={true}>
            <UserStorePage user={query.get("user")} />
          </Layout>
        )}
      />
      <Route
        path="/privacy"
        render={() => (
          <Layout>
            <PrivacyPolicy />
          </Layout>
        )}
      />
      <Route
        path="/categories"
        render={() => (
          <Layout hasSearch={true}>
            <CategoriesPage />
          </Layout>
        )}
      />
      <Route
        path="/fringe-benefit/:id"
        render={({ match }) => (
          <Layout hasSearch={true}>
            <ProductInfo id={match.params.id} />
          </Layout>
        )}
      />
      <Route
        path="/fringe-benefits"
        render={() => (
          <Layout hasSearch={true}>
            <Shop search={query.get("search")} />
          </Layout>
        )}
      />
      <Route exact path="/" render={() => <LandingPage />} />
      {/* Link personalizado da loja: extraconomy.com/<slug> (ou /<idioma>/<slug>) */}
      <Route
        exact
        path="/:slug([^/.]+)"
        render={({ match }) => <StoreSlugRoute slug={match.params.slug} />}
      />
      <Route render={() => <LandingPage />} />
    </Switch>
  );
};

export default StoreRoutes;
